// extracted by mini-css-extract-plugin
export default {"videoInner":"VideoPlayerViewer_videoInner__TtdWG","posterImage":"VideoPlayerViewer_posterImage__RAgga","posterOverlay":"VideoPlayerViewer_posterOverlay__KraZy"};